import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { fetchGuestCart, fetchUserCart, logout, removeFromCart } from "../store"
import { Link, useNavigate } from "react-router-dom"
import { cartQuantity, cartTotal } from "../util"
import Spinner from "./Spinner"
import RemoveFromCartButton from "./RemoveFromCartButton"
import CartItem from "./CartItem"
import "./styles/Cart.css"

const Cart = () => {
  const cart = useSelector((state) => state.cart)
  const auth = useSelector((state) => state.auth)
  const product = useSelector((state) => state.product)

  const dispatch = useDispatch()
  const navigate = useNavigate()

  useEffect(() => {
    if (auth.id) {
      dispatch(fetchUserCart())
    } else {
      dispatch(fetchGuestCart())
    }
  }, [])

  const cartItems = cart && cart.cartItems ? cart.cartItems : []
  const totalPrice = cartTotal(cart.cartItems)
  const totalItems = cartQuantity(cart.cartItems)

  return (
    <div>
      <h1 className="cart-title">Cart</h1>
      <hr />
      <div className="cart-container">
        <div className="cart-items">
          {cartItems.map((product) => (
            <CartItem key={product.product.id} product={product} />
          ))}
        </div>
        <div className="cart-summary">
          <div className="cart-total">
            <div className="total-price">Total: {totalPrice}</div>
          </div>
          <div className="total-items">{totalItems} Items</div>
          <button
            className="checkout-button"
            onClick={() => {
              navigate("/orders/verify")
            }}
          >
            Checkout
          </button>
        </div>
      </div>
    </div>
  )
}

export default Cart
